import { render } from "./BuildCardsPage.vue?vue&type=template&id=22c6eda7&scoped=true"
import script from "./BuildCardsPage.vue?vue&type=script&lang=js"
export * from "./BuildCardsPage.vue?vue&type=script&lang=js"

import "./BuildCardsPage.vue?vue&type=style&index=0&id=22c6eda7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c6eda7"]])

export default __exports__